
import { Options, Vue } from "vue-class-component";
import CheckCircle from "@/app/ui/components/icons/modules/check-circle.vue";
import Card from "@/app/ui/components/card/index.vue";
import DetailClientParent from "../../global-components/form-sections/client-parent.vue";
import Tax from "../../global-components/form-sections/tax.vue";
import ContactInfo from "../../global-components/form-sections/contact-information.vue";
import PaymentInfo from "../../global-components/form-sections/payment-information.vue";
import BillingInfo from "../../global-components/form-sections/billing-information.vue";
import Agreement from "../../global-components/form-sections/agreement.vue";
import BankInfo from "../../global-components/form-sections/bank-information.vue";
import PriceTypeForm from "../../global-components/price-type-form.vue";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { convertArrayToString, convertPhoneNumber, formatDateNormal, formatDateNumber } from "@/app/infrastructures/misc/Utils";
import { capitalize } from "vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { BankDetail } from "@/domain/entities/ClientRegistration";
import { formatDate } from "@/app/infrastructures/misc/Utils";
import { DistrictData } from "@/domain/entities/Location";
import { resolveTaxValidationConfig, TaxValidationConfig } from "@/domain/client/validation";

@Options({
  components: {
    CheckCircle,
    Card,
    DetailClientParent,
    Tax,
    ContactInfo,
    PaymentInfo,
    BillingInfo,
    Agreement,
    BankInfo,
    PriceTypeForm,
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (this.hasChanged && !this.openSuccess && !this.isErrorDocument) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      ClientRegistrationController.setOpenModalSuccess(false);
      ClientRegistrationController.setErrorDocument(false);
      next();
    }
  },
  watch: {}
})
class AddClientRegistration extends Vue {
  isMYDistrict = false;

  mounted() {
    this.form = {
      clientParent: {
        companyName: "",
        clientCategory: "",
        companySize: "",
        address: "",
        district: "",
        email: "",
        phone: "",
        isNeedAssessment: true
      },
      tax: {
        NIK: "",
        NIKAddress: "",
        NIKName: "",
        taxNumber: "",
        taxPayerName: "",
        taxPayerAddress: "",
        transactionCode: "",
        isEfakturWithNik: false
      },
      contact: {
        name: "",
        level: "",
        email: "",
        phone: ""
      },
      payment: {
        paymentMethod: "",
      },
      billing: {
        noWhatsApp: "",
        billingSchedule: "",
        timeRangePayment: "",
        email: [],
      },
      agreement: {
        startDate: "",
        endDate: "",
        attachment: "",
        fileNameAttachment: "",
        attachmentUrl: "",
      },
      isInsurance: false,
      customRates: 2,
      insurance: "",
      originCities: [{ name: this.$t("clientManagement.priceTypeForm.all3lc").toString(), value: "All" }],
      retailBasedDistrict: false,
      versionBasic: "",
      isCustomRate: "retail",
      discount: "",
      priceRateStartDate: "",
      priceRateEndDate: "",
      versionName: "",
      archiveFile: "",
      parent: {
        parentName: "",
        posName: "",
        commision: "",
        commisionType: "",
        numeratorCommission: ""
      },
      cod: false,
      do: false,
      codRej: {
        receiverName: "",
        receiverAddress: "",
        district: "",
        commision: "",
        padCommision: "",
        phone: "",
        codAmountType: "",
        codShipmentDiscount: ""
      },
      clientBranchDoPaymentType: "",
      clientIsDfod: false,
      isReturnConfig: false,
      returnConfigLimit: 7,
      returnConfigReasonIds: [{ "name": this.$t("clientManagement.registrationBranchForm.returnConfig.allReasons").toString(), "value": "all" }],
    };
    this.form.priceRateStartDate = new Date(
      this.$moment()
        .add(1, "days")
        .startOf("day")
        .toDate()
    );
    this.form.priceRateEndDate = new Date(
      this.$moment()
        .add(2, "days")
        .startOf("day")
        .toDate()
    );
    ClientRegistrationController.setBankDetail(new BankDetail());
    ClientRegistrationController.setBankDetailSettlement(new BankDetail());
    this.form.originCities = [
      {
        name: this.$t("clientManagement.priceTypeForm.all3lc").toString(),
        value: "All"
      }
    ];
    this.form.returnConfigReasonIds = [
      {
        name: this.$t(
          "clientManagement.registrationBranchForm.returnConfig.allReasons"
        ).toString(),
        value: "all"
      }
    ];
    ClientRegistrationController.getManagingCountry();
  }

  get managingCountryOptions() {
    return ClientRegistrationController.managingCountryList;
  }

  mergeClientParentData(payload: Record<string, unknown>) {
    this.form.clientParent = { ...this.form.clientParent, ...payload };
  }

  mergeContactData(payload: Record<string, unknown>) {
    this.form.contact = { ...this.form.contact, ...payload };
  }

  mergeBillingData(payload: Record<string, unknown>) {
    this.form.billing = { ...this.form.billing, ...payload };
  }

  // route navigation
  async goBack() {
    await this.$router.push("/client/client-registration");
  }

  get getTitle() {
    return this.$route.meta.name;
  }

  isFirstStep = true;
  switchStep(step: number) {
    if (step === 0) {
      this.isFirstStep = true;
    } else {
      this.isFirstStep = false;
    }
  }

  get isFormFirstStepValid() {
  return (
    this.isClientParentValid() &&
    this.isTaxValid() &&
    this.isContactValid() &&
    this.isPaymentValid() &&
    this.isBillingValid() &&
    this.isAgreementValid() &&
    !this.anyFormError
  );
}

get anyFormError() {
  const hasError = (obj: any): boolean => {
    return Object.values(obj).some(value =>
      typeof value === 'object' && value !== null
        ? hasError(value)
        : typeof value === 'boolean'
        ? value
        : false
    );
  };
  return hasError(this.error);
}

  get _isClientParentValidOne() {
    const { clientParent } = this.form;
    return (
      clientParent.companyName &&
      clientParent.companyAlias &&
      clientParent.clientCategory
    );
  }

  get _isClientParentValidTwo() {
    const { clientParent } = this.form;
    return (
      clientParent.companySize?.value &&
      clientParent.address &&
      clientParent.district &&
      clientParent.managingCountry?.code
    );
  }

  get _isClientParentValidThree() {
    const { clientParent } = this.form;
    return clientParent.email && clientParent.phone;
  }

  get isUsingNik() {
    const { tax } = this.form;
    return (
      !!tax.NIK &&
      !!tax.NIKAddress &&
      !!tax.NIKName &&
      !!tax.transactionCode?.value &&
      !!tax.attachment
    );
  }

  get isWithoutUsingNik() {
    const { tax } = this.form;
    return (
      !!tax.taxNumber &&
      !!tax.taxName &&
      !!tax.taxAddress &&
      !!tax.transactionCode?.value &&
      !!tax.attachment
    );
  }

  isClientParentValid() {
    return (
      this._isClientParentValidOne &&
      this._isClientParentValidTwo &&
      this._isClientParentValidThree
    );
  }

  isTaxValid() {
    const { tax } = this.form;
    if (tax.isEfakturWithNik) {
      return this.isUsingNik
    } else {
      return this.isWithoutUsingNik
    }
  }

isContactValid() {
  const { contact } = this.form;
  return (
    contact.name &&
    contact.level &&
    contact.email &&
    contact.phone
  );
}

isPaymentValid() {
  return this.form.payment.paymentMethod?.value;
}

isBillingValid() {
  const { billing } = this.form;
  return (
    billing.noWhatsApp &&
    billing.billingSchedule?.value &&
    billing.timeRangePayment?.value &&
    billing.email?.length
  );
}

isAgreementValid() {
  const { agreement } = this.form;
  return (
    agreement.startDate &&
    agreement.endDate &&
    agreement.attachment
  );
}



  get isFormSecondStepValid() {
    let result = false;

    if (this.form.isCustomRate === "retail") {
      if (
        !this.form.isInsurance ||
        (this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }

    if (this.form.isCustomRate === "normal") {
      const discountValid = this.form.useClientDiscountConfig
        ? Array.isArray(this.form.discount) &&
          this.form.discount.length > 0 &&
          this.form.discount.every(
            (item: any) => item?.product?.name && item?.discount
          )
        : true;

      if (
        (this.form.versionBasic &&
          this.form.originCities.length &&
          discountValid &&
          !this.error.discount &&
          !this.form.isInsurance) ||
        (this.form.versionBasic &&
          this.form.originCities.length &&
          discountValid &&
          !this.error.discount &&
          this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }

    if (this.form.isCustomRate === "khusus") {
      if (
        (this.form.versionName &&
          this.form.archiveFile.name &&
          !this.form.isInsurance) ||
        (this.form.versionName &&
          this.form.archiveFile.name &&
          this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }

    if (this.form.isCustomRate === "kombinasi") {
      const discountValid = this.form.useClientDiscountConfig
        ? Array.isArray(this.form.discount) &&
          this.form.discount.length > 0 &&
          this.form.discount.every(
            (item: any) => item?.product?.name && item?.discount
          )
        : true;

      if (
        (this.form.versionName &&
          this.form.versionBasic &&
          this.form.originCities.length &&
          discountValid &&
          !this.error.discount &&
          this.form.archiveFile.name &&
          !this.form.isInsurance) ||
        (this.form.versionName &&
          this.form.versionBasic &&
          this.form.originCities.length &&
          discountValid &&
          !this.error.discount &&
          this.form.archiveFile.name &&
          this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }

    return (
      result && !this.error.priceRateStartDate && !this.error.priceRateEndDate
    );
  }

  get districtList() {
    return ClientRegistrationController.districtList;
  }

  form: any = {
    clientParent: {
      companyName: "",
      clientCategory: "",
      companySize: "",
      address: "",
      district: "",
      email: "",
      phone: "",
      phoneDialCode: "",
      isNeedAssessment: true,
      perusahaan: "",
      managingCountry: null
    },
    tax: {
      NIK: "",
      NIKAddress: "",
      NIKName: "",
      taxNumber: "",
      taxPayerName: "",
      taxPayerAddress: "",
      transactionCode: "",
      isEfakturWithNik: false
    },
    contact: {
      name: "",
      level: "",
      email: "",
      phone: "",
      phoneDialCode: ""
    },
    payment: {
      paymentMethod: "",
    },
    billing: {
      noWhatsApp: "",
      noWhatsAppDialCode: "",
      billingSchedule: "",
      timeRangePayment: "",
      email: [],
    },
    agreement: {
      startDate: "",
      endDate: "",
      attachment: "",
      fileNameAttachment: "",
      attachmentUrl: "",
    },
    isInsurance: false,
    customRates: 2,
    insurance: "",
    originCities: [{ name: "All 3LC", value: "All" }],
    retailBasedDistrict: false,
    versionBasic: "",
    isCustomRate: "retail",
    discount: "",
    priceRateStartDate: "",
    priceRateEndDate: "",
    versionName: "",
    archiveFile: "",
    parent: {
      parentName: "",
      posName: "",
      commision: "",
      commisionType: "",
      numeratorCommission: ""
    },
    cod: false,
    do: false,
    codRej: {
      receiverName: "",
      receiverAddress: "",
      district: "",
      commision: "",
      padCommision: "",
      phone: "",
      codAmountType: "",
      codShipmentDiscount: ""
    },
    clientBranchDoPaymentType: "",
    clientIsDfod: false,
    isReturnConfig: false,
    returnConfigLimit: 7,
    returnConfigReasonIds: [{ "name": "All reasons", "value": "all" }],
    useClientDiscountConfig: true
  };

  error = {
    clientParent: {
      email: false,
      phone: false,
      alias: false
    },
    tax: {
      taxNumber: false,
      taxFile: false
    },
    contact: {
      contactEmail: false,
      contactPhone: false,
    },
    billing: {
      emailBilling: false,
      contactWhatsApp: false,
    },
    agreement: {
      invalidDate: false,
      documentFrp: false,
      documentPks: false
    },
    customRates: false,
    versionBasic: false,
    discount: false,
    priceRateStartDate: false,
    priceRateEndDate: false,
    versionName: false,
    archiveFile: false,
    commision: false,
    codRejdistrict: false,
    codRejCommision: false,
    codRejPhone: false,
    padCommision: false,
    codRejShipmentDiscount: false
  };

  get customPriceOption() {
    return [
      {
        label: this.$t(
          "clientManagement.renewalRateCard.priceTypeRetail"
        ).toString(),
        value: "retail",
        description: this.$t(
          "clientManagement.priceTypeForm.retailPriceDescription"
        ).toString(),
        disabled: false
      },
      {
        label: this.$t(
          "clientManagement.renewalRateCard.priceTypeNormal"
        ).toString(),
        value: "normal",
        description: this.$t(
          "clientManagement.priceTypeForm.normalPriceDescription"
        ).toString(),
        disabled: false
      },
      {
        label: this.$t(
          "clientManagement.renewalRateCard.priceTypeCustom"
        ).toString(),
        value: "khusus",
        description: this.$t(
          "clientManagement.priceTypeForm.customPriceDescription"
        ).toString(),
        disabled: false
      },
      {
        label: this.$t(
          "clientManagement.renewalRateCard.priceTypeCombination"
        ).toString(),
        value: "kombinasi",
        description: this.$t(
          "clientManagement.priceTypeForm.combinationPriceDescription"
        ).toString(),
        disabled: false
      }
    ];
  }

  get validateStartEndDate() {
    const endDate = new Date(
      this.form.priceRateEndDate.getFullYear(),
      this.form.priceRateEndDate.getMonth(),
      this.form.priceRateEndDate.getDate()
    );
    const startDate = new Date(
      this.form.priceRateStartDate.getFullYear(),
      this.form.priceRateStartDate.getMonth(),
      this.form.priceRateStartDate.getDate()
    );
    const value =
      startDate.getTime() > endDate.getTime() ||
      startDate.getTime() === endDate.getTime() ||
      endDate.getTime() < startDate.getTime() ||
      endDate.getTime() === startDate.getTime();
    this.error.priceRateStartDate = value;
    this.error.priceRateEndDate = value;
    return value;
  };

  // close/back from create
  isAddTerminated = false;
  newPath = "";
  answer = false;

  get hasChanged() {
    return !!(
      this.form.clientParent.companyName ||
      this.form.clientParent.address ||
      this.form.clientParent.email ||
      this.form.archiveFile ||
      this.form.discount ||
      this.form.clientParent.phone ||
      this.form.tax.taxNumber ||
      this.form.versionBasic ||
      this.form.priceRateStartDate ||
      this.form.priceRateEndDate ||
      this.form.versionName
    );
  }

  onOpenClosePage(to: any) {
    this.isAddTerminated = true;
    this.newPath = to.path;
  }

  handlerClose() {
    this.isAddTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isAddTerminated = false;
  }

  handleErrorClose() {
    ClientRegistrationController.setErrorEdit(false);
  }

  // Error Document
  get isErrorDocument() {
    return ClientRegistrationController.isErrorDocument;
  }

  get bankDetail(): any {
    return ClientRegistrationController.bankDetail;
  }

  get bankDetailSettlement(): any {
    return ClientRegistrationController.bankDetailSettlement;
  }

  // get Price Type
  get priceType() {
    let priceTypeVal = "";
    const lowerCustomRate = this.form.isCustomRate.toLowerCase();
    if (lowerCustomRate === 'retail') priceTypeVal = 'retail';
    if (lowerCustomRate === 'normal' && this.form.originCities[0].value === 'All' && !this.form.retailBasedDistrict) priceTypeVal = 'normal';
    if (lowerCustomRate === 'normal' && this.form.originCities[0].value !== 'All' && !this.form.retailBasedDistrict) priceTypeVal = 'normal_custom_3lc';
    if (lowerCustomRate === 'normal' && this.form.originCities[0].value === 'All' && this.form.retailBasedDistrict) priceTypeVal = 'normal_retail_district';
    if (lowerCustomRate === 'normal' && this.form.originCities[0].value !== 'All' && this.form.retailBasedDistrict) priceTypeVal = 'normal_custom_3lc_retail_district';
    if (lowerCustomRate === 'khusus' && !this.form.retailBasedDistrict) priceTypeVal = 'custom_client';
    if (lowerCustomRate === 'khusus' && this.form.retailBasedDistrict) priceTypeVal = 'custom_client_retail_district';
    if (lowerCustomRate === 'kombinasi' && this.form.originCities[0].value === 'All' && !this.form.retailBasedDistrict) priceTypeVal = 'combination';
    if (lowerCustomRate === 'kombinasi' && this.form.originCities[0].value !== 'All' && !this.form.retailBasedDistrict) priceTypeVal = 'combination_custom_3lc';
    if (lowerCustomRate === 'kombinasi' && this.form.originCities[0].value === 'All' && this.form.retailBasedDistrict) priceTypeVal = 'combination_retail_district';
    if (lowerCustomRate === 'kombinasi' && this.form.originCities[0].value !== 'All' && this.form.retailBasedDistrict) priceTypeVal = 'combination_custom_3lc_retail_district';
    return priceTypeVal;
  }

  get insurancePercentage() {
    return this.form.isInsurance && this.form.insurance === 'custom-rates' ? Number(Number('0.' + this.form.customRates).toFixed(2)) : 0
  }

  // Save data
  /* eslint-disable @typescript-eslint/camelcase */

  async _onAdd() {
    this.onCloseSave();
    this.handleErrorClose();

    const add = await ClientRegistrationController.addClientRegistration(this.payloadOnAdd);

    if (add) {
      this.openSuccess = true;
      await this.goBack();
      MainAppController.setSnackbarMessage(
        this.$t("clientManagement.registrationFlow.parentCreationSuccess", {
          clientName: this.form.clientParent.companyName,
        }).toString()
      );
      MainAppController.setAutoClose(true);
      MainAppController.setSnackbar(true);
      MainAppController.setSnackbarTimeout(3000);
      ClientRegistrationController.setBankDetailSettlement(new BankDetail({}));
      ClientRegistrationController.setBankDetail(new BankDetail({}));
    }
  }

  get payloadOnAdd() {
    const payload = {
      ...this.getClientParentPayload(),
      ...this.getTaxPayload(),
      ...this.getContactPayload(),
      ...this.getPaymentPayload(),
      ...this.getBillingPayload(),
      ...this.getAgreementPayload(),
      ...this.getPricePayload(),
      ...this.getBankPayload(),
      ...this.getOtherPayload(),
    };

    return payload;
  }

  formatDate(date: any) {
    return formatDate(date)
  }

  isOpen3LC = false;

  setIsOpen3LC() {
    this.isOpen3LC = true;
  }

  setIsClose3LC() {
    this.isOpen3LC = false;
  }

  // Helper method for clientParent payload
  getClientParentPayload() {
    const { clientParent } = this.form;
    const payload: any = {
      companyName: clientParent.companyName,
      client_alias: clientParent.companyAlias,
      category: clientParent.clientCategory.value,
      company_size: capitalize(clientParent.companySize.value),
      address: clientParent.address,
      district: clientParent.district,
      email: clientParent.email,
      phone: this.isMYDistrict ? `60${clientParent?.phone}` : convertPhoneNumber(clientParent?.phone),
      isNeedAssessment: clientParent.isNeedAssessment,
      useClientDiscountConfig: !!this.form.useClientDiscountConfig
    };
    if (clientParent.managingCountry?.code) {
      payload.managingCountryCode = clientParent.managingCountry.code;
    }
    return payload;
  }

// Helper method for tax payload
getTaxPayload() {
  const { tax } = this.form;
  return {
    taxpayer_name: tax.taxName,
    taxpayer_address: tax.taxAddress,
    taxNumber: tax.taxNumber,
    transaction_code: tax.transactionCode.value,
    taxAttachment: tax.attachment,
    isEfakturWithNik: tax.isEfakturWithNik,
    nikId: tax.NIK,
    nikName: tax.NIKName,
    nikAddress: tax.NIKAddress
  };
}

// Helper method for contact payload
getContactPayload() {
  const { contact } = this.form;
  return {
    contactName: contact.name,
    contactJobTitle: contact.level,
    contactEmail: contact.email,
      contactPhone: this.isMYDistrict ? `60${contact?.phone}` : convertPhoneNumber(contact?.phone),
  };
}

// Helper method for payment payload
getPaymentPayload() {
  return {
    payment_method: this.form.payment.paymentMethod.value,
  };
}

// Helper method for billing payload
getBillingPayload() {
  const { billing } = this.form;
  return {
      billing_wa_number: this.isMYDistrict ? `60${billing?.noWhatsApp}` : convertPhoneNumber(billing?.noWhatsApp),
    billing_schedule_so: billing.billingSchedule.value.startsWith("bi")
      ? "Bi-Weekly"
      : capitalize(billing.billingSchedule.value),
    billing_payment_periode: `${billing.timeRangePayment.value} Days`,
    billing_email: convertArrayToString(billing.email, "name"),
  };
}

// Helper method for agreement payload
getAgreementPayload() {
  const { agreement } = this.form;
  return {
    contract_start_date: formatDateNumber(agreement.startDate),
    contract_end_date: formatDateNumber(agreement.endDate),
    contract_attachment: agreement.attachment,
    pksAttachment: agreement.pksAttachment,
  };
}

getAdjustedStartDate() {
  const startDate = this.form.priceRateStartDate;
  if (this.form.isCustomRate === "retail") {
    return this.$moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ssZ");
  }
  return this.formatDateForPayload(startDate);
}

getAdjustedEndDate() {
  let endDate = this.form.priceRateEndDate;
  if (this.form.isCustomRate === "retail") {
    endDate = this.form.agreement.endDate;
    return this.$moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ssZ");
  }
  return this.$moment(endDate).format("YYYY-MM-DDTHH:mm:ssZ");
}

formatDateForPayload(date: Date) {
  return this.$moment(date).format("YYYY-MM-DDTHH:mm:ssZ");
}

// Helper method for price payload
getPricePayload() {
  const startDate = this.getAdjustedStartDate();
  const endDate = this.getAdjustedEndDate();

  const { isCustomRate, versionBasic, versionName, archiveFile, insurance, originCities } = this.form;
  let { discount } = this.form;

  if (!Array.isArray(discount)) discount = [];

  const findValueSemua = discount.find((item: any) => item.product.name === "SEMUA");
  const mapDiscountProduct =
  findValueSemua
  ? null
  : discount.filter((d: any) => d.product.name).map((item: any) => {
    return {
      product_type: item.product.name,
      discount: Number(item.discount.replace(/,/g, "."))
    }
  })
  const discountPrice = findValueSemua ? Number(discount[0].discount.replace(/,/g, ".")) : 0;

  return {
    versionBasic: isCustomRate === 'khusus' || isCustomRate === 'retail'
      ? { rateVersionName: "" }
      : versionBasic,
    isCustomRate: isCustomRate === 'kombinasi',
    isCustomRateOnly: isCustomRate === 'khusus',
    discount: discountPrice,
    discountProductTypes: mapDiscountProduct,
    priceRateStartDate: startDate,
    priceRateEndDate: endDate,
    versionName: isCustomRate ? versionName : "",
    archiveFile: isCustomRate ? archiveFile : "",
    custom_price_type: isCustomRate.toUpperCase(),
    price_type: this.priceType,
    insurance_type: this.form.isInsurance ? (insurance === 'custom-rates' || insurance === 'custom') ? 'custom' : 'bundling' : '',
    insurance_percentage: this.insurancePercentage,
    "3lc_origin": originCities[0].value === 'All' ? '' : originCities.map((oc: any) => oc.name).join(', '),
  };
}

// Helper method for bank payload
getBankPayload() {
  const { bankDetail, bankDetailSettlement } = this;
  return {
    bankName: bankDetail.bankName.value || bankDetail.bankName,
    bankAccountName: bankDetail.accountName,
    bankAccountNumber: bankDetail.accountNo,
    bankAccountEmail: bankDetail.email,
    bankAccountLabel: bankDetail.bankLabel,
    va_bank_name: bankDetailSettlement.bankName.name ?? "",
    va_bank_account_name: bankDetailSettlement.accountName ?? "",
    va_bank_number: bankDetailSettlement.accountNo ?? "",
    va_bank_email: bankDetailSettlement.email,
    va_bank_label: bankDetailSettlement.bankLabel
      ? `${bankDetailSettlement.bankLabel.toUpperCase()} Virtual Account`
      : "",
  };
}

// Helper method for other payload fields
getOtherPayload() {
  return {
    type: "parent",
    client_type: "parent",
    is_efaktur_with_nik: false,
    nik_id: "",
    nik_name: "",
    nik_address: "",
    version: "v2",
  };
}

  openSuccess = false;

  get openSave() {
    return ClientRegistrationController.openModal;
  }
  onOpenSave() {
    ClientRegistrationController.setOpenModal(true);
  }
  onCloseSave() {
    ClientRegistrationController.setOpenModal(false);
  }

  formateRatePeriod(start: string, end: string) {
    const isSameMonthYear =
      formatDateNormal(start, "MMMM-YYYY") ===
      formatDateNormal(end, "MMMM-YYYY");

    return `${formatDateNormal(
      start,
      isSameMonthYear ? "DD" : "DD MMMM YYYY"
    )} - ${formatDateNormal(end, "DD MMMM YYYY")}`;
  }

  get periodeHarga() {
    let endDate = this.form.priceRateEndDate;

    if (this.form.isCustomRate === "retail") {
      endDate = this.form.agreement.endDate;
    }

    return this.formateRatePeriod(this.form.priceRateStartDate, endDate);
  }

  get customConfirmMesage() {
    let template = '';
    if (this.form.isCustomRate === 'retail') {
      template = `
        <div class='font-semibold text-base mb-4'>${this.$t('clientManagement.registrationFlow.parentRegisterConfirmationTitle')}</div>
        <div class='bg-gray-lp-1000 rounded-xl py-4 px-6 flex text-sm justify-between text-left flex-wrap'>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold mr-2'>${this.$t('clientManagement.renewalRateCard.pricePeriod')}</div>
          <div class ='mr-2'>${this.periodeHarga || '-'}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold ml-2'>${this.$t('clientManagement.renewalRateCard.price')}</div>
          <div class='ml-2'>${this.$t('clientManagement.renewalRateCard.priceTypeRetail')}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold mr-2'>${this.$t('clientManagement.renewalRateCard.insuranceCalculation')}</div>
          <div class='mr-2'>${this.insuranceSummaryText}</div>
        </div>
      `
    }
    if (this.form.isCustomRate === 'normal') {
      template = `
        <div class='font-semibold text-base mb-4'>${this.$t('clientManagement.registrationFlow.parentRegisterConfirmationTitle')}</div>
        <div class='bg-gray-lp-1000 rounded-xl py-4 px-6 text-sm text-left'>
        <div class='w-1/2 mb-3'>
          <div class='font-semibold mb-1'>${this.$t('clientManagement.registrationFlow.priceCustomization')}</div>
          <div>${this.$t('clientManagement.renewalRateCard.normalPrice')}</div>
        </div>
        <div class='pt-2 mb-3 border-t border-gray-lp-1600 flex justify-between gap-4'>
          <div class='w-1/2'>
            <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.priceTypeNormal')}</div>
            <div>${this.form.versionBasic?.rateVersionName}</div>
          </div>
          <div class='w-1/2'>
            <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.origin3lc')}</div>
            <div>${this.form.originCities?.length || 0} </div>
          </div>
        </div>
        <div class='pt-2 mb-3 border-t border-gray-lp-1600 flex justify-between gap-4'>
          <div class='w-1/2'>
            <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.price')}</div>
            <div>${this.$t('clientManagement.renewalRateCard.normalPrice')}</div>
          </div>
          <div class='w-1/2'>
            <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.pricePeriod')}</div>
            <div>${this.periodeHarga}</div>
          </div>
        </div>
        <div class='pt-2 border-t border-gray-lp-1600 flex justify-between gap-4'>
          <div class='w-1/2'>
            <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.insuranceCalculation')}</div>
            <div class='mr-2'>${this.insuranceSummaryText}</div>
          </div>
        </div>
      `
    }
    if (this.form.isCustomRate === 'khusus') {
      template = `
        <div class='font-semibold text-base mb-4'>${this.$t('clientManagement.registrationFlow.parentRegisterConfirmationTitle')}</div>
        <div class='bg-gray-lp-1000 rounded-xl py-4 px-6 flex text-sm justify-between text-left flex-wrap'>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.pricePeriod')}</div>
          <div>${this.periodeHarga}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.registrationFlow.priceCustomization')}</div>
          <div>${this.$t('clientManagement.renewalRateCard.customPrice')}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.price')}</div>
          <div>${this.$t('clientManagement.renewalRateCard.uploaded')}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.customPrice')}</div>
          <div>${this.form.archiveFile.name}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.weightCalculation')}</div>
          <div>${this.$t('clientManagement.renewalRateCard.chargeableWeightRoundingActive')}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.insuranceCalculation')}</div>
          <div class='mr-2'>${this.insuranceSummaryText}</div>
        </div>
      `
    }
    // ${this.$t('clientManagement.renewalRateCard.')}
    if (this.form.isCustomRate === 'kombinasi') {
      template = `
        <div class='font-semibold text-base mb-4'>${this.$t('clientManagement.registrationFlow.parentRegisterConfirmationTitle')}</div>
        <div class='bg-gray-lp-1000 rounded-xl py-4 px-6 flex text-sm justify-between text-left flex-wrap'>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold mr-2'>${this.$t('clientManagement.renewalRateCard.pricePeriod')}</div>
          <div class='mr-2'>${this.periodeHarga}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.registrationFlow.priceCustomization')}</div>
          <div>${this.$t('clientManagement.renewalRateCard.priceTypeCombination')}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold mr-2'>${this.$t('clientManagement.renewalRateCard.price')}</div>
          <div class='mr-2'>${this.$t('clientManagement.renewalRateCard.uploaded')}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold'>${this.$t('clientManagement.renewalRateCard.customPrice')}</div>
          <div>${this.form.archiveFile.name}</div>
        </div>
        <div class='w-1/2 mb-2'>
          <div class='font-semibold mr-2'>${this.$t('clientManagement.renewalRateCard.insuranceCalculation')}</div>
          <div class='mr-2'>${this.insuranceSummaryText}</div>
        </div>
      `
    }

    return template;
  }

  get insuranceSummaryText() {
    if (!this.form.isInsurance) {
      return this.$t('clientManagement.renewalRateCard.retailTiering').toString();
    }
    if (this.form.insurance === 'custom-rates') {
      return `${this.$t('clientManagement.renewalRateCard.customRates')} 0,${this.form.customRates}%`;
    }
    return this.$t('clientManagement.registrationFlow.free').toString();
  }

  clearAffectedChangeDistrict() {
    this.form.clientParent.phone = "";
    this.form.contact.phone = "";
    this.form.billing.noWhatsApp = "";
    this.form.tax.taxNumber = "";
    this.form.tax.NIK = "";
  }

  onChangeDistrict(item: DistrictData) {
    const isMYDistrict = item.countryCode === "MY";

    if (this.isMYDistrict !== isMYDistrict && item.countryCode) {
      this.clearAffectedChangeDistrict();
    }

    this.isMYDistrict = isMYDistrict;
  }
  
  get isManagingCountryMalaysia() {
    return (
      (this.form.clientParent.managingCountry?.code ||
        (this.isMYDistrict ? "MY" : "ID")) === "MY"
    );
  }

  get taxValidationConfig(): TaxValidationConfig | undefined {
    return resolveTaxValidationConfig(
      this.form.clientParent.managingCountry?.code ||
        (this.isMYDistrict ? "MY" : "ID")
    );
  }
}

export default AddClientRegistration;
